//https://betterprogramming.pub/how-to-authentication-users-with-token-in-a-react-application-f99997c2ee9d

import React from "react";
import { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import ProfessionPicker from "./ProfessionPicker";
import NationPicker from "./NationPicker";
import LanguagePicker from "./LanguagePicker";
import i18n from "i18next";

async function LoginUser(credentials) {
  const address = process.env.REACT_APP_SERVER_URL_LOGIN_CHECK;
  return fetch(address, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      return data;
    })
    .catch((error) => console.log(error));
}

async function UpdateUserPassword(credentials) {
  const address = process.env.REACT_APP_SERVER_URL_UPDATE_USER_PASSWORD;
  return fetch(address, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      return data;
    })
    .catch((error) => console.log(error));
}

async function CreateUser(users) {
  const address = process.env.REACT_APP_SERVER_URL_CREATE_USER;
  return fetch(address, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(users),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      return data;
    })
    .catch((error) => console.log(error));
}

const Login = ({ setToken }) => {
  const [userName, setUserName] = useState();
  const [password, setPassword] = useState();
  const [oldpassword, setOldPassword] = useState();
  const [register, setRegister] = useState();
  const [changePassword, setChangePassword] = useState();
  const [loginmsg, setLoginmsg] = useState();
  const [registermsg, setRegistermsg] = useState();

  const [email, setEmail] = useState();
  const [name, setName] = useState();
  const [lastname, setLastname] = useState();
  const [job, setJob] = useState(1);
  const [company, setCompany] = useState();
  const [role, setRole] = useState(1);
  const [taxcode, setTaxcode] = useState();
  const [vatnumber, setVatnumber] = useState();
  const [nation, setNation] = useState(113);
  const [province, setProvince] = useState();
  const [city, setCity] = useState();
  const [postalcode, setPostalcode] = useState();
  const [address, setAddress] = useState();
  const [phone, setPhone] = useState();
  const [language, setLanguage] = useState(1);
  const [acceptlegalNotes, setAccept] = useState();

  const JobRef = useRef(null);
  const NationRef = useRef(null);
  const LanguageRef = useRef(null);

  const handleSubmit = async (e) => {
    setLoginmsg("");
    e.preventDefault();
    const token = await LoginUser({
      userName,
      password,
    });
    if (token) {
      if (token["value"]) {
        setToken(token["value"]);
        sessionStorage.setItem("user", JSON.stringify(token["username"]));
        sessionStorage.setItem("email", JSON.stringify(token["email"]));
      } else {
        setToken("");
        setLoginmsg(token["message"]);
      }
    } else {
      setToken("");
      setLoginmsg(t("SomethingWrong"));
    }
  };

  const handleSubmitChangePassword = async (e) => {
    setLoginmsg("");
    e.preventDefault();
    const token = await UpdateUserPassword({
      userName,
      oldpassword,
      password
    });
    if (token) {
      if (token["value"]) {
        setToken(token["value"]);
        sessionStorage.setItem("user", JSON.stringify(token["username"]));
        sessionStorage.setItem("email", JSON.stringify(token["email"]));
      } else {
        setToken("");
        setLoginmsg(token["message"]);
      }
    } else {
      setToken("");
      setLoginmsg(t("SomethingWrong"));
    }
  };

  const handleRegister = (e) => {
    e.preventDefault();
    setChangePassword("");
    setRegister("r");
  };

  const handleChangePassword = (e) => {
    e.preventDefault();
    setChangePassword("c");
    setRegister("");
  };

  const handleReturnLogin = (e) => {
    e.preventDefault();
    setChangePassword("");
    setRegister("");
    setToken("");
    setLoginmsg("");
  };

  const handleRegisterUser = async (e) => {
    e.preventDefault();
    setRegistermsg("");
    setNation(NationRef.current.getData());
    setJob(JobRef.current.getData());
    setLanguage(LanguageRef.current.getData());
    
    const user = await CreateUser({
      email,
      name,
      lastname,
      job,
      company,
      taxcode,
      vatnumber,
      nation,
      province,
      city,
      postalcode,
      address,
      phone,
      language,
      acceptlegalNotes: acceptlegalNotes ? 1 : 0,
      role,
    });
    if (user) {
      setRegistermsg(user["message"]);
    } else {
      setRegistermsg(t("SomethingWrong"));
    }
  };

  const { t } = useTranslation();

  function getNotes() {
    const language = i18n.language;
    if (language === "it") {
      return "Note_IT.pdf";
    } else if (language === "de") {
      return "Note_DE.pdf";
    } else {
      return "Notes_EN.pdf";
    }
  }

  if (!register && !changePassword) {
    return (
      <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <img className="mx-auto h-10 w-auto" src="./roofrox.png" alt="RoofRox" />
          <h1 className="mt-10 text-center text-4xl font-black leading-9 tracking-tight text-green-700">KEYPRO SUITE</h1>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label className="form-label">{t("EmailAddress")}</label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  onChange={(e) => setUserName(e.target.value)}
                  className="form-input"
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label className="form-label">{t("Password")}</label>
                <div className="text-sm"></div>
              </div>
              <div className="mt-2">
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-input"
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded-md bg-green-800 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-green-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                {t("Login")}
              </button>
            </div>
            <div>
              <label className="form-error">{loginmsg}</label>
            </div>
          </form>

          <form className="space-y-6" onSubmit={handleRegister}>
            <div className="pt- w-full justify-center">
              <label className="pr-1 text-green-600">{t("NotAMember")}</label>
              <button name="btnregister" type="submit" className="font-bold fjustify-center text-green-600 dark:text-green-700 text-center hover:underline">
                {t("Register")}
              </button>
            </div>
          </form>
          <form className="space-y-6" onSubmit={handleChangePassword}>
            <div className="pt- w-full justify-center">
              <label className="pr-1 text-green-600">{t("NotRememberPassword")}</label>
              <button name="btnregister" type="submit" className="font-bold fjustify-center text-green-600 dark:text-green-700 text-center hover:underline">
                {t("ResettaPassword")}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  } 
  else if (changePassword) {
    return (
      <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <img className="mx-auto h-10 w-auto" src="./roofrox.png" alt="RoofRox" />
          <h1 className="mt-10 text-center text-4xl font-black leading-9 tracking-tight text-green-700">KEYPRO SUITE</h1>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form className="space-y-6" onSubmit={handleSubmitChangePassword}>
            <div>
              <label className="form-label">{t("EmailAddress")}</label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  onChange={(e) => setUserName(e.target.value)}
                  className="form-input"
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label className="form-label">{t("VecchiaPassword")}</label>
                <div className="text-sm"></div>
              </div>
              <div className="mt-2">
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  onChange={(e) => setOldPassword(e.target.value)}
                  className="form-input"
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label className="form-label">{t("NuovaPassword")}</label>
                <div className="text-sm"></div>
              </div>
              <div className="mt-2">
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-input"
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded-md bg-green-800 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-green-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                {t("ChangePassword")}
              </button>
            </div>
            <div>
              <label className="form-error">{loginmsg}</label>
            </div>
          </form>

          <form className="space-y-6" onSubmit={handleReturnLogin}>
            <div className="pt- w-full justify-center">
              <button name="btnregister" type="submit" className="font-bold fjustify-center text-green-600 dark:text-green-700 text-center hover:underline">
                &#129028; {t("RitornaLogin")}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
  else {
    return (
      <div className="justify-center">
        <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <img className="mx-auto h-10 w-auto" src="./roofrox.png" alt="RoofRox" />
            <h1 className="mt-5 text-center text-2xl font-black leading-9 tracking-tight text-green-700">KEYPRO SUITE - {t("Register")}</h1>
          </div>
        </div>

        <form className="flex flex-wrap mx-10 mb-10" onSubmit={handleRegisterUser}>
          <div className="form-col1_3">
            <div>
              <label className="form-label">{t("Emailrequired")}</label>
              <input className="form-input required" type="email" onChange={(e) => setEmail(e.target.value)} />
            </div>
          </div>
          <div className="form-col1_3">
            <div>
              <label className="form-label">{t("Name")}</label>
              <input className="form-input required" type="text" onChange={(e) => setName(e.target.value)} />
            </div>
          </div>
          <div className="form-col1_3">
            <div>
              <label className="form-label">{t("Lastname")}</label>
              <input className="form-input required" type="text" onChange={(e) => setLastname(e.target.value)} />
            </div>
          </div>
          <div className="form-col1_3">
            <ProfessionPicker ref={JobRef} />
          </div>
          <div className="form-col1_3">
            <div>
              <label className="form-label">{t("Company")}</label>
              <input className="form-input" type="text" onChange={(e) => setCompany(e.target.value)} />
            </div>
          </div>
          <div className="form-col1_3">
            <div>
              <label className="form-label">{t("Role")}</label>
              <input className="form-input" type="text" onChange={(e) => setRole(e.target.value)} />
            </div>
          </div>
          <div className="form-col1_3">
            <div>
              <label className="form-label">{t("Taxcode")}</label>
              <input className="form-input" type="text" onChange={(e) => setTaxcode(e.target.value)} />
            </div>
          </div>
          <div className="form-col1_3">
            <div>
              <label className="form-label">{t("VatNumber")}</label>
              <input className="form-input" type="text" onChange={(e) => setVatnumber(e.target.value)} />
            </div>
          </div>
          <div className="form-col1_3">
            <LanguagePicker ref={LanguageRef} />
          </div>
          <div className="form-col1_3">
            <NationPicker ref={NationRef} />
          </div>
          <div className="form-col1_3">
            <div>
              <label className="form-label">{t("Province")}</label>
              <input className="form-input" type="text" onChange={(e) => setProvince(e.target.value)} />
            </div>
          </div>
          <div className="form-col1_3">
            <div>
              <label className="form-label">{t("City")}</label>
              <input className="form-input" type="text" onChange={(e) => setCity(e.target.value)} />
            </div>
          </div>
          <div className="form-col1_3">
            <div>
              <label className="form-label">{t("Postcode")}</label>
              <input className="form-input" type="text" onChange={(e) => setPostalcode(e.target.value)} />
            </div>
          </div>
          <div className="form-col1_3">
            <div>
              <label className="form-label">{t("Address")}</label>
              <input className="form-input" type="text" onChange={(e) => setAddress(e.target.value)} />
            </div>
          </div>
          <div className="form-col1_3">
            <div>
              <label className="form-label">{t("Phone")}</label>
              <input className="form-input" type="phone" onChange={(e) => setPhone(e.target.value)} />
            </div>
          </div>
          <div className="form-col1_1">
            <div className="flex items-center">
              <button
                type="button"
                onClick={handleReturnLogin}
                className="w-full flex mr-5 items-center justify-center w-1/2 px-5 py-2 text-sm text-gray-700 transition-colors duration-200 bg-white border rounded-lg sm:w-auto dark:hover:bg-gray-800 dark:bg-gray-900 hover:bg-gray-100 dark:text-gray-200 dark:border-gray-700"
              >
                <svg
                  className="w-5 h-5 rtl:rotate-180"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18" />
                </svg>
                <span>Go back</span>
              </button>
              <button name="btnregister" type="submit" className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-3 rounded align-left mr-5">
                {t("Register")}
              </button>
              <input
                id="link-checkbox"
                onChange={(e) => setAccept(e.target.checked)}
                type="checkbox"
                value=""
                className="w-4 h-4 text-green-600 accent-green-700"
              />
              <label for="link-checkbox" className="ms-2 text-sm mr-5 mx-10">
                {t("AccettaCondizioni")}
                <a href={getNotes()} download="Note" target="_blank" rel="noreferrer" className="text-green-600">
                  {t("Condizioni")}
                </a>
              </label>
              <label className="form-error">{registermsg}</label>
            </div>
          </div>
        </form>
      </div>
    );
  }
};

Login.propTypes = {
  setToken: PropTypes.func.isRequired,
};

export default Login;
